import { Row, Workbook, Worksheet } from "exceljs";
import { ExcelMapperConfig } from "./excel-mapper-config";

const EMIT_INTERVAL = 1000 / 60;

export class ExcelMapperConverter{
	config:ExcelMapperConfig;

	public constructor(config:ExcelMapperConfig){
		this.config = config;
	}

	private convertExcelCreateHeader(sheet:Worksheet, newSheet:Worksheet):{[key:string]:number}{
		let headerRow = sheet.getRow(this.config.HeaderRow);
		let headerObj:{[key:string]:number} = {};
		for (let i = 1; i <= headerRow.cellCount; i++){
			let cell = headerRow.getCell(i);
			let value = cell.value;
			if (value){
				headerObj[value.toString()] = i;
			}
		}

		let newRow = [];
		for (let i in this.config.Cols) {
			let col = this.config.Cols[i];
			let val = col.NewHeaderName;
			newRow.push(val);
		}
		newSheet.addRow(newRow);
		return headerObj;
	}

	private convertExcelCreateRow(sheet:Worksheet, newSheet:Worksheet, row:Row, headerObj:{[key:string]:number}){
		let rowValues:{[key:string]:any} = {};
		for (let key of Object.keys(headerObj)) {
			let index = headerObj[key];
			let value = "";
			let cellValue = row.getCell(index).value;
			if (cellValue) {
				value = cellValue.toString();
			}
			rowValues[key] = value;
		}

		let newRow = [];
		let newRowObj:any = {};
		for (let col of this.config.Cols) {
			let value = col.NewValue.getValue(rowValues, newRowObj);
			newRowObj[col.NewHeaderName]  = value;
			newRow.push(value);
		}

		newSheet.addRow(newRow);
	}

	public async start(sheet:Worksheet, onProgress?:(progress:number)=>void):Promise<Workbook>{
		let result = new Workbook();
		let newSheet = result.addWorksheet("Sheet");
		let headerObj = this.convertExcelCreateHeader(sheet, newSheet);

		let lastEmit = new Date().getTime();
		for (let i = this.config.HeaderRow+1; i <= sheet.rowCount; i++){
			let row = sheet.getRow(i);
			this.convertExcelCreateRow(sheet, newSheet, row, headerObj);
			let now = new Date().getTime();
			if (now - lastEmit > EMIT_INTERVAL && onProgress){
				let progress = (i / sheet.rowCount) * 100;
				onProgress(progress);
				lastEmit = new Date().getTime();
				await new Promise(requestAnimationFrame);
			}
		}

		return result;
	}

}